import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'cp-valued',
    templateUrl: 'cp-valued.html',
    providers: []
})
export class CpValued {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('scroll-Auto') scrollAuto: boolean;

    constructor(public element: ElementRef, private renderer: Renderer2) {

    }

    ngOnInit() {

        this.renderer.addClass(this.element.nativeElement, 'display-block');
        // this.renderer.addClass(this.element.nativeElement, 'centro-1300');

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/cp-valued/cp-valued.ts